/* Notice Component - 안내 · 경고 박스
 * - action: 오른쪽 끝에 버튼 등 배치 (title 있으면 제목 줄에 맞춰 위쪽, 없으면 세로 가운데)
 * - loading: 아이콘 대신 회전 스피너 (진행 중 안내)
 */

import { ReactNode } from 'react';
import InfoIcon from '../../assets/icons/common/info.svg?react';
import WarningIcon from '../../assets/icons/common/warning.svg?react';
import CheckCircleIcon from '../../assets/icons/common/check-circle.svg?react';
import SpinnerIcon from '../../assets/icons/common/spinner.svg?react';

export type NoticeColor = 'info' | 'success' | 'warning' | 'error';

interface NoticeProps {
  color?: NoticeColor;
  title?: ReactNode;
  /** 오른쪽 끝에 놓을 버튼 등 (예: <Button size="sm">저장</Button>) */
  action?: ReactNode;
  /** true: 아이콘 대신 회전 스피너 */
  loading?: boolean;
  className?: string;
  children?: ReactNode;
}

const ICONS: Record<NoticeColor, typeof InfoIcon> = {
  info: InfoIcon,
  success: CheckCircleIcon,
  warning: WarningIcon,
  error: WarningIcon,
};

export function Notice({ color = 'info', title, action, loading = false, className = '', children }: NoticeProps) {
  const Icon = loading ? SpinnerIcon : ICONS[color];
  return (
    <div className={`notice notice--${color}${title ? ' notice--has-title' : ''} ${className}`.trim()} role={color === 'error' || color === 'warning' ? 'alert' : 'note'}>
      <Icon className={`notice-icon${loading ? ' notice-icon--spin' : ''}`} />
      <div className="notice-content">
        {title && <div className="notice-title">{title}</div>}
        {children && <div className="notice-body">{children}</div>}
      </div>
      {action && <div className="notice-action">{action}</div>}
    </div>
  );
}

export default Notice;
